var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static"},[_c('router-view',{staticClass:"animated"}),_c('TheFooter',{staticClass:"footer-base"}),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }